import gameData from '../../gameData.js';

//shape, color, shape and color - category
//same, same, different, different - type
//12 colors, 6 donuts

/**
 * 
 * @param {*} category - shape or color
 * @param {*} type - same or different
 */
export function generateSingleRowContent(category, type)
{
    let displayArray = [];
    let tempArray = (category === "shape") ? [...gameData.shapes] : [...gameData.colors];
    let total = (type === "same") ? 4 : 2;
    for(let runs = 0;runs < total;runs++)
    {
        const rand = Math.floor(Math.random()*tempArray.length);
        displayArray.push(tempArray.splice(rand,1)[0]);
    }

    return sameDifferentCs(category, type, displayArray)
}

function sameDifferentCs(category,type,array)
{
    const answer = array[0];
    //picks a random shape or color
    //if the question is asking for shape, picks one random color to set all donuts to
    //if question is asking for color, picks one random shape to set all donuts to
    const aspect = (category === "shape") ? pickRandomShapeColor("color") : pickRandomShapeColor("shape");
    let displayObj = [];

    //if same, the array is already 4 long, and needs two answers, and 3 different shapes
    if(type === "same")
    {
        array.push(answer);
    }
    //if different the array is 2 long, and needs 4 of the same, and 1 different answer
    else
    {
        for(let runs = 0; runs < 3; runs++)
        {
            array.push(array[1])
        }
    }
    
    Phaser.Math.RND.shuffle(array);

    //creates entries based on frame names
    for(let each in array)
    {
        displayObj[each] = {frameName:"",answer:false};
        if(category === "shape")
        {
            displayObj[each].frameName = `Donuts and Sprinkles/Donut_${array[each]}_${aspect}`;
            displayObj[each].shape = array[each];
        }
        else
        {
            displayObj[each].frameName = `Donuts and Sprinkles/Donut_${aspect}_${array[each]}`;
            displayObj[each].shape = aspect;
        }
        displayObj[each].answer = (answer === array[each]);
    }

    return(displayObj);
}

/**
 * 
 * @param {*} type - same or different
 */
export function generateDoubleRowContent(type)
{
    //same and different 2 row

    return new Promise((resolve)=>{
        let returnObj;

        if(type === "same") returnObj = sameDoubleRow();
        else returnObj = differentDoubleRow();

        resolve(returnObj);
    })
}

export function differentDoubleRow()
{
    //console.log("diff double");
    let displayObj = [];
    let tempColor = [...gameData.colors];
    let tempShape = [...gameData.shapes];
    let differArrayColor = [];
    let differArrayShape = [];
    let evalObj = {};

    let rand = Math.floor(Math.random()*tempColor.length);
    const colorAns = tempColor.splice(rand,1)[0];

    rand = Math.floor(Math.random()*tempShape.length);
    const shapeAns = tempShape.splice(rand,1)[0];

    //create answer
    displayObj.push({
        frameName: `Donuts and Sprinkles/Donut_${shapeAns}_${colorAns}`,
        shape:shapeAns,
        answer:true
    });

    //create three random donuts, from an array exlcuding the answer
    //this is made from seperate arrays, to s
    for(let runs = 0; runs < 3; runs++)
    {
        rand = Math.floor(Math.random()*tempShape.length);
        const shapeExtra = tempShape.splice(rand,1)[0];
        rand = Math.floor(Math.random()*tempColor.length);
        const colorExtra = tempColor.splice(rand,1)[0];
        differArrayColor.push(colorExtra);
        differArrayShape.push(shapeExtra);

        displayObj.push({
            frameName: `Donuts and Sprinkles/Donut_${shapeExtra}_${colorExtra}`,
            shape:shapeExtra,
            answer:false
        });
    }
    for(let x in differArrayColor)
    {
        evalObj[differArrayColor[x]] = {count:1,type:"color",name:differArrayColor[x]};
        evalObj[differArrayShape[x]] = {count:1,type:"shape",name:differArrayShape[x]};
    }

    //console.log(evalObj);
    //generate 6 additional donuts, that will always share a trait with the three created above
    for(let runs = 0; runs < 5; runs++)
    {
        rand = Math.floor(Math.random()*differArrayShape.length);
        const shapeExtra = differArrayShape[rand];
        rand = Math.floor(Math.random()*differArrayColor.length);
        const colorExtra = differArrayColor[rand];

        evalObj[shapeExtra].count++;
        evalObj[colorExtra].count++;

        displayObj.push({
            frameName: `Donuts and Sprinkles/Donut_${shapeExtra}_${colorExtra}`,
            shape:shapeExtra,
            answer:false
        });
    }

    //console.log(evalObj);

    for(let x in evalObj)
    {
        if(evalObj[x].count === 1 && displayObj.length < 10)
        {
            //console.log("needs more donut")
            if(evalObj[x].type === "color")
            {
                rand = Math.floor(Math.random()*differArrayShape.length);
                const shapeExtra = differArrayShape[rand];

                displayObj.push({
                    frameName: `Donuts and Sprinkles/Donut_${shapeExtra}_${evalObj[x].name}`,
                    shape:shapeExtra,
                    answer:false
                });
            } 
            else
            {
                rand = Math.floor(Math.random()*differArrayShape.length);
                const colorExtra = differArrayColor[rand];

                displayObj.push({
                    frameName: `Donuts and Sprinkles/Donut_${evalObj[x].name}_${colorExtra}`,
                    shape:evalObj[x].name,
                    answer:false
                });
            }
        }
    }

    if(displayObj.length < 10)
    {
        rand = Math.floor(Math.random()*differArrayShape.length);
        const shapeExtra = differArrayShape[rand];
        rand = Math.floor(Math.random()*differArrayColor.length);
        const colorExtra = differArrayColor[rand];

        displayObj.push({
            frameName: `Donuts and Sprinkles/Donut_${shapeExtra}_${colorExtra}`,
            shape:shapeExtra,
            answer:false
        });
    }

    //console.log(displayObj.length)
    
    Phaser.Math.RND.shuffle(displayObj);

    //console.log(displayObj);
    return (displayObj);
}

export async function sameDoubleRow()
{
    //console.log("same double");
    let displayObj = [];
    let tempColor = [...gameData.colors];
    let tempShape = [...gameData.shapes];
    const usedDonutMap = new Map();

    let rand = Math.floor(Math.random()*tempColor.length);
    const colorAns = tempColor[rand];

    rand = Math.floor(Math.random()*tempShape.length);
    const shapeAns = tempShape[rand];

    displayObj.push({
        frameName: `Donuts and Sprinkles/Donut_${shapeAns}_${colorAns}`,
        shape:shapeAns,
        answer:true
    });
    displayObj.push({
        frameName: `Donuts and Sprinkles/Donut_${shapeAns}_${colorAns}`,
        shape:shapeAns,
        answer:true
    });

    usedDonutMap.set(shapeAns+colorAns,true);

    for(let runs = 0; runs < 8; runs++)
    {
        let shapeExtra, colorExtra;

        [shapeExtra,colorExtra] = await pickBothShapeColor(usedDonutMap);

        displayObj.push({
            frameName: `Donuts and Sprinkles/Donut_${shapeExtra}_${colorExtra}`,
            shape:shapeExtra,
            answer:false
        });
    }

    Phaser.Math.RND.shuffle(displayObj);

    return(displayObj);
}

/**Used to return unique shapes and colors using a map
 * 
 * @param {*} map 
 * @returns 
 */
function pickBothShapeColor(map)
{
    return new Promise((resolve)=>
    {
        let mapCheck;
        let returnArray = [];
        let rand;
        do
        {
            returnArray = [];
            rand = Math.floor(Math.random()*gameData.shapes.length);
            returnArray.push(gameData.shapes[rand]);
            rand = Math.floor(Math.random()*gameData.colors.length);
            returnArray.push(gameData.colors[rand]);
            mapCheck = returnArray[0] + returnArray[1];
            //console.log("stuck forever", map.has(mapCheck))

        } while(map.has(mapCheck))
        map.set(mapCheck,true);
        resolve(returnArray);
    });
}

/**Returns a random shape or color based on category given
 * 
 * @param {string} category - shape or color
 * @returns {string} - specific shape or color
 */
function pickRandomShapeColor(category)
{
    const length = (category === "color") ? gameData.colors.length : gameData.shapes.length;
    const rand = Math.floor(Math.random()*length);
    return (category === "color") ? gameData.colors[rand] : gameData.shapes[rand];
}